<template>
  <div class="row center-xs mb20">
    <template v-if="rentType === 'single'">
      <div class="row col-xs-12 radio-input-wrapper mb20">
        <label class="col-xs-12 uppercase align-left pl0 weight-600" for="">{{ $t("Choose Period") }}</label>
        <div v-for="period in sortedPeriods" :key="period" class="radio-input relative flexible mt5">
          <input
            :id="period + 'period'"
            type="radio"
            name="period"
            :value="period"
            @change="updatePeriod()"
            v-model="getActivePeriod"
          >
          <label :for="period + 'period'" class="radioStyled">
            <template v-if="period === 3">
              {{ $t('try on') }}
            </template>
            <template v-else>
              <p class="m0 fs13">{{ getStringForPeriod(period) }}</p>
              <p class="m0 fs13"><b>{{ getPriceForPeriod(period) | price(storeView) }}</b></p>
            </template>
          </label>
        </div>
      </div>
    </template>
    <label v-if="rentType === 'tryOn'" class="col-xs-12 uppercase align-left weight-600">{{ $t("Home try-on 24h") }}</label>
    <label v-else class="col-xs-12 uppercase align-left weight-600">{{ calendarLabel }}</label>
    <div class="col-xs-12 mt5">
      <!-- todo :class="[{ 'active' : getSelectedDate }, { 'disabled': isAddToCartDisabled || isDisabled }]" -->
      <button class="toggle-calendar" :class="[{ 'active' : getSelectedDate }, { 'disabled': isDisabled }]" @click="showCalendarModal">
        <div class="flex center-xs">
          <template v-if="getSelectedDate">
            {{ getSelectedDate }}
          </template>
          <template v-else>
            <span>{{ $t('Check availability') }}</span>
            <img class="pl20 pb5" src="/assets/calendar.svg" alt="calendar">
          </template>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { currentStoreView } from '@vue-storefront/core/lib/multistore'

export default {
  name: 'RentPeriod',
  props: {
    rentType: {
      type: String,
      default: 'single',
      required: true
    }
  },
  computed: {
    ...mapGetters({
      getPeriods: 'calendar/getPeriods',
      getDate: 'calendar/getDate',
      getSelectedDate: 'calendar/getSelectedDate',
      getCurrentProduct: 'product/getCurrentProduct',
      getUserBalance: 'user/getBalance',
      isLogged: 'user/isLoggedIn'
    }),
    calendarLabel () {
      return this.rentType === 'subscription' ? this.$t('Rental period - 4 days') : this.$t('Choose date of rent')
    },
    getActivePeriod: {
      get () {
        return this.$store.state.calendar.period
      },
      set (value) {
        this.$store.commit('calendar/updatePeriod', value)
      }
    },
    isSubscriptionAvaliable () {
      return this.getCurrentProduct.subscription_points
    },
    isEnoughPoints () {
      return this.getUserBalance >= 1
    },
    isDisabled () {
      return this.rentType === 'subscription' && (!this.isEnoughPoints || !this.isLogged)
    },
    sortedPeriods () {
      let periods = this.avaliablePeriods.filter(period => period !== 3)
      return periods && periods.sort((a, b) => {
        let left, right
        let lettersOrder = [2, 4, 7, 3]
        left = lettersOrder.indexOf(a)
        right = lettersOrder.indexOf(b)
        if (left < right) { return -1 }
        if (left > right) { return 1 }
        return 0
      })
    },
    avaliablePeriods () {
      return this.isSubscriptionAvaliable && this.isEnoughPoints
        ? this.getPeriods.filter(period => period === 4)
        : this.getPeriods
    },
    storeView () {
      return currentStoreView()
    }
  },
  beforeMount () {
    this.$bus.$on('resetCalendarDate', this.resetCalendarDate)
  },
  beforeDestroy () {
    this.$bus.$off('resetCalendarDate', this.resetCalendarDate)
  },
  methods: {
    getStringForPeriod (period) {
      if (period === 2 || period === 1) {
        return '1' + ' ' + this.$t('day')
      } else {
        return period + ' ' + this.$t('days')
      }
    },
    getPriceForPeriod (period) {
      return this.getCurrentProduct.sirental_price.find(price => price.period === period - 1 + 'd').price
    },
    updatePeriod () {
      this.$store.dispatch('calendar/updateCalendarData')
      if (this.rentType === 'single') this.$emit('updatePeriod', this.getActivePeriod)
      this.resetCalendarDate()
    },
    showCalendarModal () {
      let subscriptionRentPeriod
      if (this.rentType === 'subscription') subscriptionRentPeriod = 4
      if (this.rentType === 'tryOn') subscriptionRentPeriod = 3
      this.$store.commit('calendar/updatePeriod', subscriptionRentPeriod)
      this.$bus.$emit('modal-show', 'modal-calendar')
    },
    resetCalendarDate () {
      this.$store.commit('calendar/setDate', null)
      this.$store.commit('calendar/setDateValidation', true)
      this.$store.commit('calendar/setSelectedDate', '')
    }
  }
}
</script>

<style lang="scss" scoped>
.toggle-calendar {
  &.disabled {
    pointer-events: none;
    background-color: gray;
    color: white;
    opacity: 0.3;
  }
  &.active {
    box-shadow: 0px 0px 0px 2px #3e3e3e !important;
    border-color: white;
  }
  &.active:hover {
    border-color: white;
  }
  &:hover {
    border-color: black;
  }
  padding: 10px 0px;
  width: 100%;
  text-align: center;
  border: 1px solid #DCDCDC;
  color: #646464;
  display: block;
  font-family: 'Poppins', Arial;
  text-transform: uppercase;
  font-size: 14px;
  background-color: white;
}
.radio-input {
   label {
    padding: 6px 14px;
    text-align: center;
    border: 1px solid #DCDCDC;
    color: #646464;
    display: block;
    text-transform: uppercase;
    font-size: 14px;
    cursor: pointer;
  }
  input {
    display: none;
    position: absolute;
    top: 3px;
    left: 0;
    &:checked + label {
      box-shadow: 0px 0px 0px 2px #3e3e3e !important;
      color: black;
      background-color: #F5D2D2;
    }
    &:hover,
    &:focus {
      + label {
        box-shadow: 0px 0px 0px 1px #3e3e3e;
      }
    }
    &:disabled + label {
      opacity: 0.5;
      pointer-events: none;
    }
  }
}
.flexible {
  flex: 1;
  &:nth-last-of-type(1){
    padding-left: 8px;
  }
  &:nth-last-of-type(2){
    padding-left: 8px;
    padding-right: 8px;
  }
  &:nth-last-of-type(3){
    padding-right: 8px;
  }
}
.fs13 {
  font-size: 12px;
}
</style>
